import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=5e4a411d&scoped=true"
import script from "./MainInfo.vue?vue&type=script&lang=js"
export * from "./MainInfo.vue?vue&type=script&lang=js"
import style0 from "./MainInfo.vue?vue&type=style&index=0&id=5e4a411d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a411d",
  null
  
)

export default component.exports